import { render } from "./PerformanceContent.vue?vue&type=template&id=0d23a2c6&scoped=true"
import script from "./PerformanceContent.vue?vue&type=script&lang=js"
export * from "./PerformanceContent.vue?vue&type=script&lang=js"

import "./PerformanceContent.vue?vue&type=style&index=0&id=0d23a2c6&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d23a2c6"]])

export default __exports__